var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDossier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 378,
    height: 378,
    viewBox: "0 0 378 378",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M236.25 126H339.255C333.756 111.429 325.214 98.1992 314.197 87.1921L259.324 32.2876C248.304 21.2835 235.07 12.7468 220.5 7.24512V110.25C220.5 118.948 227.552 126 236.25 126Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M346.122 157.5H236.25C210.155 157.5 189 136.345 189 110.25V0.378C186.464 0.204504 183.929 0 181.361 0H110.25C66.779 0.052418 31.5519 35.2795 31.5002 78.7502V299.25C31.5519 342.72 66.779 377.948 110.25 378H267.749C311.22 377.948 346.447 342.72 346.5 299.25V165.139C346.5 162.572 346.295 160.036 346.122 157.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDossier);
export default __webpack_public_path__ + "static/media/dossier.28fb7a26410a1a8f6a1becd22149e97b.svg";
export { ForwardRef as ReactComponent };